module.exports = __webpack_public_path__ + "images/excel_image.png";